import React, { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useSelector } from "react-redux";
import GlobalContext from "../../framework/GlobalContext";
import TextInput from "../../framework/TextInput";
import classes from "./EmailConfigPanel.module.css";
import ConfigurationContext from "./ConfigurationContext";

const EmailCongifPanel = (props) => {
  const { IMAP_HOST, IMAP_PORT, SMTP_HOST, SMTP_PORT } = useSelector(
    (state) =>
      state.commonReducer.tabs[state.commonReducer.activeTabIndex].configData
  );
  const { formLabels } = useContext(ConfigurationContext);

  const { setCurrentComponent } = useContext(GlobalContext);

  const [imapHost, setImapHost] = useState(IMAP_HOST);
  const [imapPort, setImapPort] = useState(IMAP_PORT);
  const [smtpHost, setSmtpHost] = useState(SMTP_HOST);
  const [smtpPort, setSmtpPort] = useState(SMTP_PORT);

  const configImapHostRef = useRef();

  useEffect(() => {
    setCurrentComponent("email_config_imap_host");
    configImapHostRef?.current.focus({ preventScroll: true });
  }, [setCurrentComponent]);

  return (
    <div className={classes["emailconfigpanel-main-container"]}>
      <div className={classes["emailconfigpanel-settings-text"]}>
        Email Settings
      </div>
      <div className={classes["emailconfigpanel-sub-container"]}>
        <div className={classes["emailconfigpanel-textbox-style"]}>
          <TextInput
            id="email_config_imap_host"
            name="imapHost"
            ref={configImapHostRef}
            label={formLabels?.IMAP_HOST?.displayName}
            value={imapHost}
            onFocus={() => setCurrentComponent("email_config_imap_host")}
            onChange={(e) => {
              setImapHost(e.target.value);
              props.handleFormChange("IMAP_HOST", e.target.value, "EMAIL");
              //   handleTextFormChange(e, "MAX_SALES_QUANTITY");
            }}
          />
        </div>
        <div className={classes["emailconfigpanel-textbox-style"]}>
          <TextInput
            id="email_config_imap_port"
            name="distributorName"
            label={formLabels?.IMAP_PORT?.displayName}
            value={imapPort}
            onFocus={() => setCurrentComponent("email_config_imap_port")}
            onChange={(e) => {
              setImapPort(e.target.value);
              props.handleFormChange("IMAP_PORT", e.target.value, "EMAIL");
            }}
          />
        </div>
        <div className={classes["emailconfigpanel-textbox-style"]}>
          <TextInput
            id="email_config_smtp_host"
            name="smtpHost"
            // ref={maxSalesQuantity}
            label={formLabels?.SMTP_HOST?.displayName}
            value={smtpHost}
            onFocus={() => setCurrentComponent("email_config_smtp_host")}
            onChange={(e) => {
              setSmtpHost(e.target.value);
              props.handleFormChange("SMTP_HOST", e.target.value, "EMAIL");
            }}
          />
        </div>
        <div className={classes["emailconfigpanel-textbox-style"]}>
          <TextInput
            id="email_config_smtp_port"
            name="smtpPort"
            label={formLabels?.SMTP_PORT?.displayName}
            value={smtpPort}
            onFocus={() => setCurrentComponent("email_config_smtp_port")}
            onChange={(e) => {
              setSmtpPort(e.target.value);
              props.handleFormChange("SMTP_PORT", e.target.value, "EMAIL");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailCongifPanel;
